module.exports = __webpack_public_path__ + "img/icon_capability03.1f2686c1.png";